






















































import { MetaInfo } from 'vue-meta'
import { Component, Mixins, Watch } from 'vue-property-decorator'

// Components
import DepositoryViewToggle from '@/components/views/depository/DepositoryViewToggle.vue'
import KnowledgeBaseFolderCard from '@/components/cards/KnowledgeBaseFolderCard.vue'
import KnowledgeBaseFolderRow from '@/components/rows/KnowledgeBaseFolderRow.vue'
import KnowledgeBaseMediaCard from '@/components/cards/KnowledgeBaseMediaCard.vue'
import KnowledgeBaseFolderTable from '@/components/tables/KnowledgeBaseFolderTable.vue'
import Attachment from '@/components/_uikit/Attachment.vue'
import ButtonArrow from '@/components/_uikit/buttons/ButtonArrow.vue'
import NoDataFound from '@/components/NoDataFound.vue'
// Mixins
import NotifyMixin from '@/mixins/NotifyMixin'
import PermissionsMixin from '@/mixins/PermissionsMixin'
// Store
import MasterDepositoryModule from '@/store/modules/master/depository'
// Types
import { LargeKnowledgeResource, KnowledgeTreeResource, IMasterDepositoryView } from '@/store/types'

@Component({
  components: {
    ButtonArrow,
    DepositoryViewToggle,
    KnowledgeBaseFolderCard,
    KnowledgeBaseFolderRow,
    KnowledgeBaseMediaCard,
    KnowledgeBaseFolderTable,
    NoDataFound,
    Attachment,
  },
})
export default class DepositoryMonthFoldersView extends Mixins(NotifyMixin, PermissionsMixin) {
  private folder: LargeKnowledgeResource | null = null

  private get view() {
    return MasterDepositoryModule.depositoryView
  }

  private get currentFolderInTree() {
    return this.findFolderInTree(this.folders, this.folderID)
  }

  private get monthID () {
    return +this.$route.params.monthID
  }

  private get courseID () {
    return +this.$route.params.courseID
  }

  private get folderID () {
    return +this.$route.params.folderID
  }

  private get foldersTree () {
    return MasterDepositoryModule.trainingFilesTree
  }

  private get course () {
    return MasterDepositoryModule.courses.data.find(course => course.id === this.courseID)
  }

  private get title() {
    const month = MasterDepositoryModule.trainingFilesMonth.folders.find(f => f.id === this.monthID)
    return month?.title
  }

  private get folders() {
    return MasterDepositoryModule.trainingFilesTree
  }

  private get currentFolderChildren() {
    const children = this.currentFolderInTree?.children ?? []
    return children
  }

  private get currentFolderMedia() {
    const media = this.folder?.media ?? []
    return media
  }

  private get isEmpty() {
    return !this.currentFolderChildren.length && !this.currentFolderMedia.length
  }

  private get breadcrumbs () {
    if (!this.course) {
      return [{ name: 'База знаний', path: { name: 'master.depository' } }]
    } else {
      return [
        { name: 'База знаний', path: { name: 'master.depository' } },
        { name: this.course.title, path: { name: 'master.depository.item', params: { courseID: this.courseID.toString() } } },
        { name: 'Учебные файлы', path: { name: 'master.depository.item.files', params: { courseID: this.courseID.toString() } } },
      ]
    }
  }

  private fetchCourses() {
    MasterDepositoryModule.fetchCourses()
      .catch(this.notifyError)
  }

  private fetchTree() {
    MasterDepositoryModule.fetchTrainingFilesTree({
      courseID: this.courseID,
      courseFolderID: this.monthID,
    })
      .catch(this.notifyError)
  }

  private fetchFolder() {
    MasterDepositoryModule.fetchTrainingFilesFolder({
      courseID: this.courseID,
      courseFolderID: this.monthID,
      mediaFolderID: this.folderID,
    })
      .then(response => {
        this.folder = response
      })
      .catch(err => {
        if (err && err.response && err.response.status !== 404) {
          this.notifyError(err)
        }
      })
  }

  private fetchTrainingMonthFolders() {
    MasterDepositoryModule.fetchTrainingFilesMonth({ courseID: this.courseID })
      .catch(err => {
        if (err && err.response && err.response.status === 403) {
          this.$router.replace({ name: 'master.depository' })
            .catch(() => {return})
        }
        this.notifyError(err)
      })
  }

  private findFolderInTree(folders: KnowledgeTreeResource[], folderID: number): KnowledgeTreeResource | null {
    const folder = folders.find(f => f.id === folderID)
    if (folder) return folder

    const foldersWithChildren = folders.filter(f => f.children?.length)
    if (!foldersWithChildren.length) return null

    const children = foldersWithChildren.reduce((t, f) => {
      return t = [...t, ...f.children]
    }, [] as KnowledgeTreeResource[])

    return this.findFolderInTree(children, folderID)
  }

  private handleDownload(folderID: number) {
    MasterDepositoryModule.downloadTrainingFilesFolder({
      courseID: this.courseID,
      courseFolderId: this.monthID,
      mediaFolderId: folderID,
    })
      .then(() => {
        this.notifySuccess('Формируем архив с файлами. Когда он будет готов для скачивания – придет уведомление')
      })
      .catch(this.notifyError)
  }

  private handleFolderClick(folderID: number) {
    this.$router.replace({
      name: 'master.depository.item.files.month.folder',
      params: {
        courseID: String(this.courseID),
        folderID: String(folderID),
        monthID: String(this.monthID),
      },
      replace: true,
    })
  }

  private goBack() {
    const parentFolderId = this.folder?.parentId ?? null

    if (!parentFolderId) {
      this.$router.replace({
        name: 'master.depository.item.files.month',
        params: {
          courseID: String(this.courseID),
          monthID: String(this.monthID),
        },
      })
    } else {
      this.$router.replace({
        name: 'master.depository.item.files.month.folder',
        params: {
          courseID: String(this.courseID),
          folderID: String(parentFolderId),
          monthID: String(this.monthID),
        },
      })
    }
  }

  private changeView(value: IMasterDepositoryView) {
    MasterDepositoryModule.setDepositoryView(value)
  }

  private metaInfo (): MetaInfo {
    return {
      title: 'Учебные файлы',
    }
  }

  private mounted () {
    if (!this.course || this.course.id !== this.courseID) {
      this.fetchCourses()
    }

    if (!this.foldersTree.length) {
      this.fetchTree()
    }

    if (!this.folder) {
      this.fetchFolder()
    }

    if (!MasterDepositoryModule.trainingFilesMonth.courseID || this.courseID !== MasterDepositoryModule.trainingFilesMonth.courseID) {
      this.fetchTrainingMonthFolders()
    }
  }

  @Watch('folderID')
  private watchRouterPath() {
    this.fetchFolder()
  }
}
